import {
    ColumnDefinition,
    ColumnDefinitionsDictionary,
    getColDefsForColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';
import { IndigoAppContextType } from 'app/AppContext.tsx';

export type IndexEventWidgetGridColumn =
    | 'symbol'
    | 'inet'
    | 'bbg'
    | 'net'
    | 'gross'
    | 'liquidity'
    | 'summary'
    | 'tradeCategoryLabel'
    | 'anncPrice'
    | 'anncDate'
    | 'effDate'
    | 'fullDayVolume'
    | 'closePct'
    | 'closeVolume'
    | 'region'
    | 'side';

export const indexEventsWidgetGridColumnsDefinitionDictionary: ColumnDefinitionsDictionary<IndexEventWidgetGridColumn> =
    {
        symbol: {
            field: 'symbol',
            name: 'Symbol',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
        side: {
            field: 'side',
            name: 'Side',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
        inet: {
            field: 'inet',
            name: 'Instinet Symbol',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
        bbg: {
            field: 'bbg',
            name: 'Bloomberg Symbol',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
        net: {
            field: 'net',
            name: 'Net Shares',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'Net',
            width: 80,
        },
        gross: {
            field: 'gross',
            name: 'Gross Shares',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'gross',
            width: 80,
        },
        liquidity: {
            field: 'liquidity',
            name: 'Liquidity (%ADV)',
            valueType: ValueType.NUMBER,
            precision: 0,
            headerTooltip: 'liquidity',
            width: 80,
        },
        summary: {
            field: 'summary',
            name: 'Summary',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },

        tradeCategoryLabel: {
            field: 'tradeCategoryLabel',
            name: 'Trade Category',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 120,
        },
        anncPrice: {
            field: 'anncPrice',
            name: '	Announcement close price',
            headerText: 'Ann Close price',
            valueType: ValueType.NUMBER,
            textAlign: 'left',
            width: 80,
        },
        anncDate: {
            field: 'anncDate',
            headerText: 'Ann Date',
            name: 'Announcement Date',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
        effDate: {
            field: 'effDate',
            name: 'Effective Date',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
        fullDayVolume: {
            field: 'fullDayVolume',
            name: 'Full Day Volume Forecast',
            valueType: ValueType.NUMBER,
            textAlign: 'left',
            width: 80,
        },
        closePct: {
            field: 'closePct',
            name: 'Close Pct Forecast',
            valueType: ValueType.NUMBER,
            textAlign: 'left',
            width: 80,
        },
        closeVolume: {
            field: 'closeVolume',
            name: 'Close Volume Forecast',
            valueType: ValueType.NUMBER,
            textAlign: 'left',
            width: 80,
        },
        region: {
            field: 'region',
            name: 'Region',
            valueType: ValueType.STRING,
            textAlign: 'left',
            width: 80,
        },
    };
export const indexEventWidgetColumnsDefinitions: ColumnDefinition[] =
    Object.values(indexEventsWidgetGridColumnsDefinitionDictionary);

export function getIndexEventWidgetColDefs(context: IndigoAppContextType) {
    return getColDefsForColumnDefinitionsDictionary(
        context,
        indexEventsWidgetGridColumnsDefinitionDictionary
    );
}

export const defaultColDef = { width: 80 };
